export const SLOTS = {
  title: "title",
  message: "message",
  link: "link",
  actionsEnd: "actions-end",
};

export const CSS = {
  actionsEnd: "actions-end",
  close: "notice-close",
  container: "container",
  content: "notice-content",
  icon: "notice-icon",
};
